/**
 * Created by Mark on 18/04/2017.
 */



import ApplicationServices from './base-service.js';
import Constants from '../constants/staff.js';
import Actions from '../actions/default.js';

class StaffService {

    constructor(){
        this.isAuthenticated = false;
        this.timeout = null;
    }

    createNewMember(firstName , lastName , password , email , userType){
        return ApplicationServices.call(Constants.CREATE_NEW_MEMBER , {firstName:firstName , lastName:lastName , password:password , email:email , userType:userType}).then(function(response){
            return response;
        });
    }

    getAccountsStaff(){
        return ApplicationServices.call(Constants.GET_ALL_STAFF , {}).then(function(response){
            Actions.update(Constants.UPDATE_ALL_STAFF , response.staff);
        });
    }

    isEmailAvaliable(email){
        return ApplicationServices.call(Constants.GET_DOES_EMAIL_EXISIT , {email:email}).then(function(response){
            return response.isValid
        });
    }

    editStaff(uid , firstName , lastName , password , email , passChanged , classes){
        return ApplicationServices.call(Constants.EDIT_STAFF , {password:password , classes:classes , uid:uid , firstName:firstName , lastName:lastName , email:email , passChanged:passChanged}).then(function(response){
            return response
        });
    }

    deleteStaff(userID){
        return ApplicationServices.call(Constants.DELETE_STAFF , {userID:userID}).then(function(response){
            return response
        });
    }
}


export default new StaffService();


// WEBPACK FOOTER //
// ./src/services/staff-services.js